import { Provider } from "../../../classes/provider/Provider";

const githubProvider = new Provider({
	id: "github",
	name: "GitHub",
	description:
		"GitHub provides source control, issue tracking, releases, and workflow automation for software teams.",
	websiteHomeUrl: "https://github.com/",
	websiteSupportUrl: "https://support.github.com/",
	iconUrl:
		"https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
	color: "#24292f",
});

export default githubProvider;
